import e from "./ExtensionValue.vue_vue_type_script_setup_true_lang.js";
//#region src/specification-extensions/ExtensionValue.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ExtensionValue.vue.js.map